import { motion } from 'framer-motion';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { todaysTopFive, topFiveArchive } from '../../mocks/top-five';

export default function TopFivePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <section className="pt-32 pb-20 bg-gradient-to-br from-navy via-navy-dark to-black text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-center"
          >
            <h1 className="font-display font-bold text-5xl md:text-6xl mb-6">
              Daily TOP FIVE
            </h1>
            <p className="text-xl text-white/80 max-w-2xl mx-auto">
              Curated lists of essential knowledge, strategies, and insights updated daily
            </p>
          </motion.div>
        </div>
      </section>

      <section className="py-20 bg-gradient-to-br from-gray-50 to-baby-blue/10">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="bg-white rounded-2xl p-8 md:p-12 shadow-2xl mb-12"
          >
            <div className="text-center mb-12">
              <div className="inline-block px-4 py-2 bg-electric-blue/20 border border-electric-blue rounded-full text-sm font-semibold text-electric-blue mb-4">
                {todaysTopFive.date}
              </div>
              <h2 className="font-display font-bold text-3xl md:text-4xl text-navy mb-2">
                Today's Top Five
              </h2>
              <p className="text-lg text-gray-600">{todaysTopFive.category}</p>
            </div>

            <div className="space-y-6">
              {todaysTopFive.items.map((item, index) => (
                <motion.div
                  key={item.rank}
                  initial={{ opacity: 0, x: -20 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: index * 0.1 }}
                  className="flex items-start gap-6 p-6 bg-gradient-to-r from-baby-blue/20 to-white rounded-2xl border border-baby-blue/30 hover:shadow-lg transition-all"
                >
                  <div className="flex-shrink-0 w-16 h-16 flex items-center justify-center bg-gradient-to-br from-electric-blue to-navy text-white rounded-xl font-display font-bold text-2xl shadow-lg">
                    {item.rank}
                  </div>
                  <div className="flex-1">
                    <div className="flex items-center gap-3 mb-3">
                      <div className="w-8 h-8 flex items-center justify-center">
                        <i className={`${item.icon} text-2xl text-navy`}></i>
                      </div>
                      <h3 className="font-display font-bold text-xl text-navy">{item.title}</h3>
                    </div>
                    <p className="text-sm text-gray-600 leading-relaxed">{item.description}</p>
                  </div>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center mb-12"
          >
            <h2 className="font-display font-bold text-4xl text-navy mb-4">Archive</h2>
            <p className="text-lg text-gray-600">Previous TOP FIVE lists</p>
          </motion.div>

          <div className="space-y-8">
            {topFiveArchive.map((archive, archiveIndex) => (
              <motion.div
                key={archiveIndex}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: archiveIndex * 0.1 }}
                className="bg-gradient-to-br from-baby-blue/10 to-white rounded-2xl p-8 border border-baby-blue/30"
              >
                <div className="mb-6">
                  <div className="text-sm text-gray-500 mb-1">{archive.date}</div>
                  <h3 className="font-display font-bold text-2xl text-navy">{archive.category}</h3>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
                  {archive.items.map((item) => (
                    <div
                      key={item.rank}
                      className="bg-white p-4 rounded-xl border border-gray-200 hover:border-electric-blue hover:shadow-md transition-all"
                    >
                      <div className="flex items-center gap-2 mb-2">
                        <div className="w-8 h-8 flex items-center justify-center bg-electric-blue text-white rounded-lg font-bold text-sm">
                          {item.rank}
                        </div>
                        <h4 className="font-semibold text-sm text-navy line-clamp-2">{item.title}</h4>
                      </div>
                      <p className="text-xs text-gray-600 line-clamp-3">{item.description}</p>
                    </div>
                  ))}
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 bg-gradient-to-br from-gray-50 to-baby-blue/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="bg-gradient-to-br from-navy to-navy-dark text-white rounded-2xl p-12 text-center"
          >
            <div className="w-16 h-16 flex items-center justify-center bg-electric-blue rounded-full mx-auto mb-6">
              <i className="ri-mail-line text-3xl text-white"></i>
            </div>
            <h2 className="font-display font-bold text-3xl md:text-4xl mb-4">
              Get Daily TOP FIVE in Your Inbox
            </h2>
            <p className="text-lg text-white/80 mb-8 max-w-2xl mx-auto">
              Subscribe to receive curated lists, insights, and strategies delivered every morning
            </p>
            <form className="max-w-md mx-auto flex gap-3">
              <input
                type="email"
                placeholder="Enter your email"
                className="flex-1 px-6 py-3 rounded-lg text-navy focus:outline-none focus:ring-2 focus:ring-electric-blue"
              />
              <button
                type="submit"
                className="px-8 py-3 bg-electric-blue text-white rounded-lg font-semibold hover:bg-blue-500 transition-colors whitespace-nowrap cursor-pointer"
              >
                Subscribe
              </button>
            </form>
          </motion.div>
        </div>
      </section>

      <Footer />
    </div>
  );
}